import React from "react";
import Spinner from "../shared/Spinner";
import "./AdminFields.css";

/* ── Text / Email / Date / Number input ── */
export function Field({ label, type = "text", value, onChange, placeholder }) {
  return (
    <div className="field-group">
      <label className="field-label">{label}</label>
      <input
        className="field-input"
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
}

/* ── Textarea ── */
export function TextArea({ label, value, onChange, placeholder, minHeight = 110 }) {
  return (
    <div className="field-group">
      <label className="field-label">{label}</label>
      <textarea
        className="field-input field-textarea"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{ minHeight }}
      />
    </div>
  );
}

/* ── Toggle switch ── */
export function Toggle({ checked, onChange, labelOn = "On", labelOff = "Off" }) {
  return (
    <div className="toggle-wrap">
      <label className="toggle">
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
        <span className="toggle-slider" />
      </label>
      <span className="toggle-label" style={{ color: checked ? "var(--red)" : "var(--muted)" }}>
        {checked ? labelOn : labelOff}
      </span>
    </div>
  );
}

/* ── Image upload area ── */
export function ImageUpload({ label, previewUrl, uploading, inputId, onFileChange }) {
  return (
    <div className="field-group">
      <label className="field-label">{label}</label>
      <div
        className={`upload-area ${uploading ? "upload-area--loading" : ""}`}
        onClick={() => !uploading && document.getElementById(inputId).click()}
      >
        {uploading ? (
          <div className="upload-loading">
            <Spinner size="md" label="Uploading image…" />
            <p>Uploading image…</p>
          </div>
        ) : (
          <>
            <div className="upload-icon">📷</div>
            <p>Click to upload image</p>
          </>
        )}
        {previewUrl && !uploading && (
          <img src={previewUrl} className="upload-preview" alt="preview" />
        )}
      </div>
      <input id={inputId} type="file" accept="image/*" style={{ display: "none" }} onChange={onFileChange} />
    </div>
  );
}

/* ── Submit / Cancel buttons ── */
export function FormActions({ onSubmit, onCancel, submitLabel = "Save", saving = false }) {
  return (
    <div className="form-actions">
      <button className="btn-submit" onClick={onSubmit} disabled={saving}>
        {saving ? (
          <><Spinner size="sm" label="Saving…" /> &nbsp;Saving…</>
        ) : submitLabel}
      </button>
      {onCancel && (
        <button className="btn-cancel" onClick={onCancel} disabled={saving}>Cancel</button>
      )}
    </div>
  );
}
